/**
 * Arama reklamları hesabı bağlamanın DURUM sözleşmesi (v3.2 D): sağlayıcı erişim seviyesi, uygulama doğrulaması ve Bağlantılar
 * ekranındaki bölümün durumu. Ayrı dosyadadır çünkü bağlantı listesi sözleşmesi (`provider-connections.ts`) de kullanır ve
 * bağlama sözleşmesi (`google-ads-connect.ts`) o dosyayı içe aktarır — döngüsüz içe aktarma. Dışa aktarım
 * `google-ads-connect.ts` üzerindendir.
 */
import { z } from 'zod';
import { googleAdsBudgetStatusSchema } from './google-ads-budget.js';
import { planQuotaStatusSchema } from './plans.js';
/**
 * Sağlayıcı API erişim seviyesi (uygulamanın bulut projesine verilir; sahip sağlayıcı panelinden yükseltir):
 *   test      yalnız TEST hesapları (üretim hesabına çağrı reddedilir)
 *   explorer  test + üretim hesapları (günlük işlem sınırı düşük)
 *   basic     test + üretim hesapları
 *   standard  test + üretim hesapları (günlük işlem sınırı yok)
 * Seviye çağrıyla öğrenilemez; ortamda BİLDİRİLİR (`GOOGLE_ADS_ACCESS_LEVEL`) ve ekranda dürüstçe gösterilir.
 */
export const GOOGLE_ADS_ACCESS_LEVELS = ['test', 'explorer', 'basic', 'standard'];
/** Üretim (test olmayan) hesaplarına erişilebilen seviye mi */
export function googleAdsProductionAccess(level) {
    return level !== 'test';
}
/**
 * Onay ekranı (uygulama) doğrulaması — ortamda bildirilir (`GOOGLE_ADS_OAUTH_VERIFICATION`):
 *   pending   doğrulama tamamlanmadı: yalnız tanımlı deneme kullanıcıları onay verebilir ve yetki 7 günde bir yenilenir
 *   verified  doğrulandı
 */
export const GOOGLE_ADS_OAUTH_VERIFICATION = ['pending', 'verified'];
/**
 * Bağlantılar ekranındaki bölümün durumu (`GET /settings/provider-connections` yanıtında `googleAdsConnect`). Gerçek kip
 * kapalıyken (`live: false`) seviye ve doğrulama bilinmez (`null`).
 */
export const googleAdsConnectStatusSchema = z.object({
    /** Gerçek kip bu süreçte açık mı (`GOOGLE_ADS=on` + yapılandırma tam) */
    live: z.boolean(),
    accessLevel: z.enum(GOOGLE_ADS_ACCESS_LEVELS).nullable(),
    verification: z.enum(GOOGLE_ADS_OAUTH_VERIFICATION).nullable(),
    /** Reklam hesabı alt kotası (sosyal medya ve arama reklam hesapları BİRLİKTE sayılır) */
    quota: planQuotaStatusSchema.optional(),
    /**
     * v3.3: sağlayıcı okuma bütçesinin bu çalışma alanı için BAĞLAMA durumu (yalnız gerçek kip açıkken). `waiting` iken bölüm
     * "bağla" düğmesi yerine dürüst bekleme metnini gösterir (hata değil). Sayı ya da başka çalışma alanı bilgisi taşımaz.
     */
    budget: googleAdsBudgetStatusSchema.optional(),
});
/**
 * Bölümün kullanıcıya gösterilen durumu (kapalı küme; her birinin ayrı metni var):
 *   flag_off              gerçek kip kapalı — düğme yok
 *   test_only             gerçek kip açık ama erişim seviyesi yalnız test hesaplarına izin veriyor — düğme var, uyarılı
 *   verification_pending  gerçek kip açık, üretim erişimi var, uygulama doğrulaması bekliyor — düğme var, uyarılı
 *   open                  kısıt bildirilmedi
 * İki kısıt birlikteyse `test_only` öne alınır (daha dar olan); doğrulama uyarısı ayrıca gösterilir.
 */
export const GOOGLE_ADS_CONNECT_STATES = [
    'flag_off',
    'test_only',
    'verification_pending',
    'open',
];
export function googleAdsConnectStateOf(s) {
    if (!s.live)
        return 'flag_off';
    // Seviye bildirilmediyse en dar varsayım (yalnız test) yapılır: olmayan erişim varmış gibi gösterilmez
    if (s.accessLevel === null || !googleAdsProductionAccess(s.accessLevel))
        return 'test_only';
    return s.verification === 'verified' ? 'open' : 'verification_pending';
}
//# sourceMappingURL=google-ads-status.js.map